// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__OXmTJ","right":"styles_right__1JkBx"};